<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4" tile>
      <v-sheet :class="showReferrals ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon @click="card()">
            <v-icon color="white">
              {{
                showReferrals ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <span class="text-body-1 white--text">Filleuls</span>
          <v-spacer />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showReferrals" class="grey lighten-4">
          <v-divider />
          <div class="">
            <v-data-table
              :headers="headers"
              fixed-header
              height="300"
              :items="customer.referrals"
              :options.sync="options"
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <template #item.used="{ item }">
                {{ item.used ? 'Oui' : 'Non' }}
              </template>
            </v-data-table>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>

import { requests } from '@/mixins';

export default {
  mixins: [requests],
  props: { customer: Object },
  data () {
    return {
      options: { itemsPerPage: 5 },
      headers: [
        { text: 'Code', value: 'id', sortable: false },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Prénom', value: 'firstname', sortable: true },
        { text: 'Nom', value: 'lastname', sortable: true },
        { text: 'Utilisé', value: 'used', sortable: true },
        { text: 'Expiration', value: 'expires_at', sortable: true },
        { text: 'Order', value: 'order', sortable: false }
      ],
      showReferrals: true
    };
  },
  methods: {
    card () {
      this.showReferrals = !this.showReferrals;
    }
  }
};
</script>

<style lang="scss">
.card-title-height {
  height: 56px;
}

</style>
